// /frontend/src/pages/dashboard/post/previews/XPreview.js
import React from 'react';

const VIDEO_EXT   = ['.mp4', '.mov', '.webm', '.avi', '.m4v'];
const PLACEHOLDER = 'https://placehold.co/40x40/000000/FFFFFF?text=X';

const isVideoUrl = (url) =>
  url && VIDEO_EXT.some((ext) => url.toLowerCase().endsWith(ext));

function MediaItem({ url }) {
  if (!url) return null;
  const video = isVideoUrl(url);
  return video ? (
    <video src={url} controls style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 8 }} />
  ) : (
    <img src={url} alt="media" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 8 }} />
  );
}

function TwitterMediaGrid({ files }) {
  const count = files.length;
  if (count === 1) {
    return (
      <div style={{ width: '100%', maxHeight: 250, borderRadius: 8, overflow: 'hidden', marginBottom: 8 }}>
        <MediaItem url={files[0].url} />
      </div>
    );
  }

  if (count === 2) {
    return (
      <div style={{ display: 'flex', width: '100%', height: 250, gap: 2, marginBottom: 8 }}>
        <div style={{ flex: 1, borderRadius: 8, overflow: 'hidden' }}>
          <MediaItem url={files[0].url} />
        </div>
        <div style={{ flex: 1, borderRadius: 8, overflow: 'hidden' }}>
          <MediaItem url={files[1].url} />
        </div>
      </div>
    );
  }

  if (count === 3) {
    return (
      <div style={{ width: '100%', height: 250, marginBottom: 8 }}>
        <div style={{ display: 'flex', gap: 2, height: '55%' }}>
          <div style={{ flex: 1, borderRadius: 8, overflow: 'hidden' }}>
            <MediaItem url={files[0].url} />
          </div>
          <div style={{ flex: 1, borderRadius: 8, overflow: 'hidden' }}>
            <MediaItem url={files[1].url} />
          </div>
        </div>
        <div style={{ display: 'flex', gap: 2, height: '45%', marginTop: 2 }}>
          <div style={{ flex: 1, borderRadius: 8, overflow: 'hidden' }}>
            <MediaItem url={files[2].url} />
          </div>
        </div>
      </div>
    );
  }

  // 4+ files: 2x2 grid, overlay +N on last cell if more than 4
  return (
    <div style={{
      display: 'grid',
      width: '100%',
      height: 250,
      gridTemplateColumns: '1fr 1fr',
      gridTemplateRows: '1fr 1fr',
      gap: 2,
      marginBottom: 8
    }}>
      {files.slice(0, 4).map((f, i) => (
        <div key={i} style={{ borderRadius: 8, overflow: 'hidden', position: 'relative', width: '100%', height: '100%' }}>
          <MediaItem url={f.url} />
          {i === 3 && files.length > 4 && (
            <div style={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(0,0,0,0.5)',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 28,
              fontWeight: 700,
              borderRadius: 8
            }}>
              +{files.length - 4}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default function XPreview({
  account,
  files,
  caption,
  postType,
  scheduleDateTime,
}) {
  const avatar      = account?.userAvatar || account?.profileImage || account?.avatarUrl || PLACEHOLDER;
  const displayName = account?.displayName || 'username';
  const handle      = account?.handle || '@handle';

  return (
    <div
      className="border rounded bg-white mb-3"
      style={{ maxWidth: 400, margin: '0 auto', fontFamily: 'Helvetica, Arial, sans-serif' }}
    >
      {/* header */}
      <div className="d-flex align-items-center p-2">
        <img
          src={avatar}
          alt="avatar"
          className="rounded-circle"
          style={{ width: 40, height: 40, objectFit: 'cover' }}
        />
        <div className="ms-2">
          <span className="fw-bold">{displayName}</span>{' '}
          <span className="text-muted">{handle}</span>{' '}
          <span className="text-muted">
            ·{' '}
            {postType === 'schedule' && scheduleDateTime
              ? new Date(scheduleDateTime).toLocaleString()
              : 'now'}
          </span>
        </div>
      </div>

      {/* caption */}
      {caption && (
        <p className="px-2" style={{ whiteSpace: 'pre-wrap', fontSize: 15 }}>
          {caption}
        </p>
      )}

      {/* media grid */}
      {files && files.length > 0 && <TwitterMediaGrid files={files} />}
    </div>
  );
}
